import React, { useState } from "react";
import { compose } from "recompose";
import { connect } from "react-redux";

import { connectToApi } from "@api/components/connectToApi";
import { Api } from "@api/index";
import { AuthState } from "@auth/models";
import { FilesState } from "@files/models";
import { ExpandButton } from "@ui/ExpandButton";
import { getLatestAlbums } from "../../selectors";
import { Album, MusicState } from "../../models";
import { AlbumsPackList } from "../AlbumsPackList";

interface LatestAlbumsStateProps {
    albums: Album[];
}

type Props = LatestAlbumsStateProps;
type State = MusicState & AuthState & FilesState;

const LatestAlbums = ({ albums }: Props) => {
    const [expanded, setExpanded ] = useState<boolean>(false);
    const albumsToShow = expanded ? albums : albums.slice(0, 4);

    return (
        <div className="latest-albums">
            <AlbumsPackList albums={albumsToShow} />
            <ExpandButton
                disabled={albums.length <= 4}
                expanded={expanded}
                toggleExpanded={() => setExpanded(!expanded)}
                />
        </div>
    );
};

const mapStateToProps = (state: State) => ({
    albums: getLatestAlbums(state),

} as LatestAlbumsStateProps);

const ConnectedLatestAlbums = compose<Props, {}>(
    connect(mapStateToProps, null),
    connectToApi({
        showRefresh: true,
        actionCreator: Api.albumsIndex,
    }),
)(LatestAlbums);

export {
    LatestAlbums as LatestAlbumsPresenter,
    ConnectedLatestAlbums as LatestAlbums,
};
